module.exports = __webpack_public_path__ + "static/media/Credits-23.a287149f.pdf";